module.exports = __webpack_public_path__ + "static/media/big-triangle.f515bec4.png";